import React, { Component } from "react";
import { loadCart, removeProduct } from "../../../services/cart/actions";

import DelayLink from "../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Ink from "react-ink";
import { connect } from "react-redux";
import { formatPrice } from "../../helpers/formatPrice";
import { updateCart } from "../../../services/total/actions";
import FeatherIcon from 'feather-icons-react';

class Cart extends Component {
	state = {
		isOpen: false,
		removeProductFromPreviousRestaurant: false,
	};
	componentDidMount() {
		const { cartProducts } = this.props;
		if (cartProducts.length) {
			this.setState({ isOpen: true });
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.newProduct !== this.props.newProduct) {
			this.addProduct(nextProps.newProduct);
		}

		if (nextProps.productToRemove !== this.props.productToRemove) {
			this.removeProduct(nextProps.productToRemove);
		}
	}

	openFloatCart = () => {
		this.setState({ isOpen: true });
	};

	closeFloatCart = () => {
		this.setState({ isOpen: false });
	};

	addProduct = (product) => {
		const { cartProducts, updateCart } = this.props;

		//get restaurant id and save to localStorage as active restaurant
		localStorage.setItem("activeRestaurant", product.restaurant_id);

		let productAlreadyInCart = false;
		cartProducts.forEach((cp) => {
			// first check if the restaurent id matches with items in cart
			// if restaurant id doesn't match, then remove all products from cart
			// then continue to add the new product to cart
			if (cp.restaurant_id === product.restaurant_id) {
				// then add the item to cart or increment count
				if (cp.id === product.id) {
					//check if product has customizations, and if the customization matches with any
					if (JSON.stringify(cp.selectedaddons) === JSON.stringify(product.selectedaddons)) {
						// increment the item quantity by 1
						cp.quantity += 1;
						productAlreadyInCart = true;
					}
				}
			} else {
				// else if restaurant id doesn't match, then remove all products from cart
				this.setState({ removeProductFromPreviousRestaurant: true });

				setTimeout(() => {
					this.setState({ removeProductFromPreviousRestaurant: false });
				}, 4 * 1000);

				cartProducts.splice(0, cartProducts.length);
			}
		});

		if (!productAlreadyInCart) {
			cartProducts.push(product);
		}

		updateCart(cartProducts);
		this.openFloatCart();
	};

	removeProduct = (product) => {
		const { cartProducts, updateCart } = this.props;

		const index = cartProducts.findIndex((p) => p.id === product.id);

		//if product is in the cart then index will be greater than 0
		if (index >= 0) {
			cartProducts.forEach((cp) => {
				if (cp.id === product.id) {
					if (cp.quantity === 1) {
						//if quantity is 1 then remove product from cart
						cartProducts.splice(index, 1);
					} else {
						//else decrement the quantity by 1
						cp.quantity -= product.quantity;
					}
				}
			});

			updateCart(cartProducts);
			if (cartProducts.length < 1) {
				this.closeFloatCart();
				localStorage.removeItem("activeRestaurant");
			}
		}
	};

	getTotalItemsInCart = () => {
		if (localStorage.getItem("countQuantityAsTotalItemsOnCart") === "true") {
			let total = 0;
			this.props.cartProducts.forEach((item) => {
				total += item.quantity;
			});
			return total;
		} else {
			return this.props.cartTotal.productQuantity;
		}
	};

	render() {
		const { cartTotal, cartProducts } = this.props;

		let classes = ["float-cart"];

		if (!!this.state.isOpen) {
			classes.push("float-cart--open");
		}

		return (
			<React.Fragment>
				{this.state.removeProductFromPreviousRestaurant && (
					<Fade duration={250} bottom>
						<div className="auth-error going-different-restaurant-notify">
							<div className="">{localStorage.getItem("itemsRemovedMsg")}</div>
						</div>
					</Fade>
				)}

				<div
					className={classes.join(" ")}
					style={{"backgroundColor":"white","color":"rgb(50, 119, 109)","width":"90%","right":"5.5%","bottom":"1rem","height":"5rem","borderRadius":"13px","fontWeight":"900","padding":"11px","border":"3px solid rgb(50, 119, 109)","fontSize":"17px"}}
				>
					{cartProducts.length ? (
						<DelayLink to={"/cart"} delay={200} className="d-flex" style={{"justifyContent":"space-between"}}>
							<div>
								<div>
								<span>
									{localStorage.getItem("currencySymbolAlign") === "left" &&
										localStorage.getItem("currencyFormat")}
									{formatPrice(cartTotal.totalPrice)}
									{localStorage.getItem("currencySymbolAlign") === "right" &&
										localStorage.getItem("currencyFormat")}
								</span>
								<span className="pl-5 pr-5">&nbsp;|&nbsp;</span>

								<span style={{color: "black"}}>
									{this.getTotalItemsInCart()} {localStorage.getItem("floatCartItemsText")}
								</span>
								{/* <span>{`${localStorage.getItem("currencyFormat")} ${formatPrice(cartTotal.totalPrice)}`}</span> */}
								{/* <span className="pull-right">
									{localStorage.getItem("floatCartViewCartText")} <i className="si si-basket" />
								</span> */}

								
								</div>
								<div style={{"fontWeight":"700","fontSize":"11px","color":"#3c3c3c"}}>
									Extra Delivery Charges And Tax May Apply
								</div>
							</div>
							<div>
									<div style={{
										backgroundColor: '#c1d5c3',
										borderRadius: '10px',
										padding: '5px'
									}}>
										<FeatherIcon icon="shopping-bag" style={{marginBottom: '-4px'}} size="25" />
									</div>
							</div>
							<Ink duration="500" />
						</DelayLink>
					) : (
						<span>&nbsp;</span>
					)}
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
	newProduct: state.cart.productToAdd,
	productToRemove: state.cart.productToRemove,
	cartTotal: state.total.data,
});

export default connect(
	mapStateToProps,
	{ loadCart, updateCart, removeProduct }
)(Cart);
